import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesSponsor } from "../../../utils/types/TalesSponsor";
import { db, storage } from "../../../firebase/config";

export const deleteSponsor = createAsyncThunk(
  "sponsor/delete",
  async (sponsor: TalesSponsor) => {
    try {
      const logoUrl = sponsor.logoUrl;
      if (logoUrl) {
        const storageRef = storage.refFromURL(logoUrl);

        const querySnapshot = await db
          .collection("sponsor")
          .where("name", "==", sponsor.name)
          .get();

        return querySnapshot.docs[0].ref
          .delete()
          .then(() => storageRef.delete());
      }
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Sponsor non eliminato, ${e.message}`);
    }
  },
);
